import { STORE_SEARCHER_FILTERS } from '@core/constants/STORE';
import { getCurrentSearcherObj } from './searcher';
import { SEARCHER_TYPES } from '@core/constants/SEARCHER';
import { updateStoreFiltersState } from './store';
import { TRIGGER_HIDE_LOADING_COMPONENT_EVENT } from '@core/constants/EVENTS';

/**
 * Update the filters state history page.
 * @param {number} newValue - The new value
 * @returns {void}
 * @private
 */
export const updateFiltersStateHistoryPage = (newValue = 0) => {
    const /** @type {object|undefined} */ currentFiltersStateHistory =
            getCurrentSearcherObj();

    if (!currentFiltersStateHistory) return;

    currentFiltersStateHistory[STORE_SEARCHER_FILTERS.PAGE_VALUE] = newValue;

    const /** @type {URLSearchParams} */ urlParams = new URLSearchParams(
            window.location.search,
        );

    updateStoreFiltersState(
        urlParams.get(SEARCHER_TYPES.SEARCHER_ID),
        currentFiltersStateHistory,
    );
};

/**
 * Update the filters state history page report.
 * @param {number} [newValue] - The new value for the page report. Default: 0.
 * @returns {void}
 * @private
 */
export const updateFiltersStateHistoryPageReport = (newValue = 0) => {
    const /** @type {object|undefined} */ currentFiltersStateHistory =
            getCurrentSearcherObj();

    if (!currentFiltersStateHistory) return;

    currentFiltersStateHistory[STORE_SEARCHER_FILTERS.PAGE_REPORT_VALUE] = newValue;

    const /** @type {URLSearchParams} */ urlParams = new URLSearchParams(
            window.location.search,
        );

    updateStoreFiltersState(
        urlParams.get(SEARCHER_TYPES.SEARCHER_ID),
        currentFiltersStateHistory,
    );
};

/**
 * Update the current page when the results are empty.
 * @param {number} currentPage - The current page
 * @returns {void}
 */
export const updateCurrentPageWhenEmptyResults = (currentPage) => {
    const /** @type {Number} */ newPageValue = currentPage - 1;

    updateFiltersStateHistoryPage(newPageValue >= 0 ? newPageValue : 0);

    document.dispatchEvent(new CustomEvent(TRIGGER_HIDE_LOADING_COMPONENT_EVENT));
};

/**
 * Update the current page report when the results are empty.
 * @param {number} currentPage - The current page
 * @returns {void}
 */
export const updateCurrentPageReportWhenEmptyResults = (currentPage) => {
    const /** @type {Number} */ newPageValue = currentPage - 1;

    updateFiltersStateHistoryPageReport(newPageValue >= 0 ? newPageValue : 0);

    document.dispatchEvent(new CustomEvent(TRIGGER_HIDE_LOADING_COMPONENT_EVENT));
};

/**
 * Update the last selected element.
 * @param {string} elementId - The element id
 * @returns {void}
 */
export const updateLastSelectedElement = (elementId) => {
    const /** @type {object|undefined} */ currentFiltersStateHistory =
            getCurrentSearcherObj();

    if (!currentFiltersStateHistory) return;

    currentFiltersStateHistory[STORE_SEARCHER_FILTERS.LAST_ELEMENT_SELECTED_ID] =
        elementId;

    const /** @type {URLSearchParams} */ urlParams = new URLSearchParams(
            window.location.search,
        );

    updateStoreFiltersState(
        urlParams.get(SEARCHER_TYPES.SEARCHER_ID),
        currentFiltersStateHistory,
    );
};
